import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";
import {Link as RouterLink} from "react-router-dom";

type Props = {
    to: string
    label: string
}

const SettingsLandingCard = ({to, label}: Props) => (
    <ButtonBase
        component={RouterLink}
        to={to}
        sx={{
            width: '100%',
            minHeight: 48,
            px: 1.5,
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            color: 'text.primary',
            bgcolor: 'background.paper',
            textAlign: 'left',
            '&:hover': {
                bgcolor: 'grey.50',
            },
            '&.Mui-focusVisible': {
                zIndex: 1,
                boxShadow: theme => `inset 0 0 0 2px ${theme.palette.primary.main}`,
            },
        }}
    >
        <Typography component="span" variant="body1" fontWeight={600} noWrap>
            {label}
        </Typography>
        <ChevronRightIcon sx={{fontSize: 18, color: 'text.secondary', flexShrink: 0}}/>
    </ButtonBase>
)

export default SettingsLandingCard
